import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormPanel, FormTextField } from '@eas/common-web';

export function Fields() {
  return (
    <>
      <FormPanel
        label={
          <FormattedMessage
            id="ZSD__ABSENCE_TYPE__DETAIL__PANEL__GENERAL"
            defaultMessage="Všeobecné"
          />
        }
      >
        <FormTextField
          name="name"
          label={
            <FormattedMessage
              id="ZSD__ABSENCE_TYPE__DETAIL__FIELD_LABEL__NAME"
              defaultMessage="Názov"
            />
          }
        />
      </FormPanel>
    </>
  );
}
